<template>
  <div class="d-flex flex-column flex-grow-1">
    <b-modal
      id="bv-modal-example"
      centered
      hide-footer
      size="lg"
      v-if="showModal"
      v-model="showModal"
    >
      <b-col class="p-0">
        <data-update-alert-modal
          extraClass="flex-column t-modal text-center"
          :date="monitoringData.revoke_date"
        />
      </b-col>
    </b-modal>
    <!-- start: INR drip switch modals -->
    <dialog-box v-if="isDialogVisible" dialogWidth="820px" @close="closeDialog">
      <!-- modal 1st enable global switch -->
      <div class="dialog-content">
        <div class="dialog-inner-container">
          <img
            src="@/assets/images/common/inr-payment-image.svg"
            alt="INR Payment Image"
            width="100%"
          />
          <div class="header">
            {{
              $t('dashboard.secondAlternateConversionRateDetailsWidget.title')
            }}
          </div>
          <div class="sub-header">
            {{
              $t(
                'dashboard.secondAlternateConversionRateDetailsWidget.subTitle'
              )
            }}
          </div>
        </div>
        <div class="button-container mt-4">
          <template v-if="confirmEnableINR">
            <div class="d-flex flex-column justify-content-center">
              <div class="button-title">
                {{
                  $t(
                    'dashboard.secondAlternateConversionRateDetailsWidget.confirmationTitle'
                  )
                }}
              </div>
              <p class="button-subtitle">
                {{
                  $t(
                    'dashboard.secondAlternateConversionRateDetailsWidget.confirmationSubtitle'
                  )
                }}
              </p>
              <div class="d-flex justify-content-center">
                <action-button
                  variant="solid"
                  class="mr-3"
                  :click="enableDripSwitchStatus"
                >
                  <b-icon-arrow-repeat
                    v-if="isAPIFullFilled"
                    animation="spin"
                    class="mr-2 color-white"
                  />
                  {{
                    $t(
                      'dashboard.secondAlternateConversionRateDetailsWidget.yesEnableButtonText'
                    )
                  }}
                </action-button>
                <action-button
                  variant="outline"
                  :click="redirectToCurrencySettings"
                >
                  {{
                    $t(
                      'dashboard.conversionRateDetailsWidget.knowMoreButtonText'
                    )
                  }}
                  <b-icon-chevron-right class="wealthy-green-color ml-2" />
                </action-button>
              </div>
            </div>
          </template>
          <template v-else>
            <action-button
              variant="solid"
              class="mr-3"
              :click="showConfirmationText"
            >
              {{
                $t('dashboard.conversionRateDetailsWidget.enableINRButtonText')
              }}
            </action-button>
            <action-button
              variant="outline"
              :click="redirectToCurrencySettings"
            >
              {{
                $t('dashboard.conversionRateDetailsWidget.knowMoreButtonText')
              }}
              <b-icon-chevron-right class="wealthy-green-color ml-2" />
            </action-button>
          </template>
        </div>
      </div>
    </dialog-box>
    <dialog-box
      v-if="isINREnabled"
      dialogWidth="600px"
      @close="onCloseIMMDialog"
    >
      <div class="inr-enabled-dialog-content">
        <lottie-player
          :src="fetchLottieJSON"
          background="transparent"
          speed="1"
          style="width: 100%; height: 110px"
          :loop="lottieLoop"
          class="mb-2"
          autoplay
        ></lottie-player>
        <div class="header">
          {{ $t('dashboard.congratulationText.title') }}
        </div>
        <div class="sub-header">
          {{ $t('dashboard.congratulationText.subtitle.prepend') }}
        </div>
        <div class="para">
          {{ $t('dashboard.congratulationText.subtitle.append') }}
        </div>
        <div class="d-flex justify-content-center">
          <action-button
            variant="solid"
            class="mr-3"
            :click="redirectToAddInvoice"
          >
            {{ $t('dashboard.congratulationText.addInvoiceText') }}
            <b-icon-chevron-right class="wealthy-green-color ml-2" />
          </action-button>
          <action-button variant="outline" :click="onCloseIMMDialog">
            {{ $t('dashboard.congratulationText.backToDashboardText') }}
          </action-button>
        </div>
      </div>
    </dialog-box>
    <!-- end: INR drip switch modals -->
    <div>
      <page-header
        :title="`Welcome ${this.$store.getters.user.name}`"
        class="mb-4"
      />
      <b-row>
        <b-col :cols="12" :md="9" :order="0" :order-md="0">
          <security-alert-banner :bannerData="securityBannerData" />
          <b-col v-if="showDataUpdateAlert" class="p-0">
            <data-update-alert-box :date="monitoringData.revoke_date" />
          </b-col>
          <primary-alert-banner v-if="showBanner" :bannerData="bannerData" />
          <legal-welcome-banner
            v-if="showLegalEsignBanner"
            :showLegalEsignBanner="showLegalEsignBanner"
            :closeModalFn="closeModalFn"
          />
          <div id="v-step-12" :class="activeTour === 2 && 'zindex'">
            <new-account-number-widget
              :class="{ expose: activeTour === 0 || activeTour === 2 }"
              @ddp="handleDdp"
            />
          </div>
          <div v-if="account && account.show_interest_rate_banner">
            <pricing-details-widget :account="account" class="pb-md-3" />
          </div>
          <template v-if="isIndia && isDripSwitchEnabled !== null">
            <div class="row quick-glance-row mt-md-3">
              <div class="col-12">
                <manage-and-conversion
                  :invoiceStageCounters="invoiceStageCounters"
                  :isDripSwitchEnabled="isDripSwitchEnabled"
                  @openDialog="showINRDialog = true"
                />
              </div>
            </div>
          </template>
          <div class="col-sm-12" v-else>
            <loader :height="60" />
          </div>
          <div class="row quick-glance-row mt-md-3">
            <div class="col-12">
              <quick-glance
                :loading="quickGlanceLoading"
                :invoiceStageCounters="invoiceStageCounters"
              />
            </div>
          </div>
          <pending-invoices-widget :monitoringData="monitoringData" />
          <advance-invoices-widget :monitoringData="monitoringData" />
          <transactions-widget :monitoringData="monitoringData" />
        </b-col>
        <b-col :cols="12" :md="3" :order="1" :order-md="1">
          <advance-p-o-widget />
          <currency-conversion
            :rate="conversionRatesData.rate"
            class="mb-3"
            v-if="isIndia"
            :isFulfilled="isRateConversionApiFulfilled"
            :isINREnabled="isDripSwitchEnabled"
          />
          <ddp-alert v-if="ddp" :ddp="ddp" />
          <!-- Remove this when corona shit is done, and everything is back to normal -->
          <alerts2
            @filter-invoices="setFiltersandRedirect"
            :customer-pending-tasks="pendingTasks"
            class="mb-3"
          />
          <warnings :lang="currentLocale" :key="currentLocale" />
          <mobile-promo />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import PendingInvoicesWidget from '@/components/dashboard/PendingInvoicesWidget'
import AdvanceInvoicesWidget from '@/components/dashboard/AdvanceInvoicesWidget'
import CurrencyConversion from '@/components/dashboard/CurrencyConversion'
import TransactionsWidget from '@/components/dashboard/TransactionsWidget'
import NewAccountNumberWidget from '@/components/dashboard/NewAccountNumberWidget'
import PricingDetailsWidget from '@/components/dashboard/PricingDetailsWidget'
import QuickGlance from '@/components/dashboard/QuickGlance'
import Warnings from '@/components/dashboard/Warnings/'
import Alerts2 from '@/components/invoices/list/Alerts'
import DialogBox from '@/components/common/DialogBox'
import ActionButton from '@/components/common/ActionButton'
import exportersService from '@/services/exporters'
import invoiceService from '@/services/invoice'
import conversionRateService from '@/services/conversionRate'
import accountsService from '@/services/accounts'
import contentfulService from '@/services/contentful'
import { freshdeskMixin } from '@/mixins/Freshdesk'
import DdpAlert from '@/components/Alerts2/DDP.vue'
import MobilePromo from '@/components/ad/MobilePromo.vue'
import moment from 'moment'
import { mapState } from 'vuex'
import {
  RATE_CONVERSION_REFETCH_DEFAULT_TIME,
  MAXIMUM_SET_TIMEOUT_DELAY
} from '@/utils/constants'
import PageHeader from '@/components/common/PageHeader'
import Confetti from '@/assets/images/lottie/confetti.json'
import PrimaryAlertBanner from '@/components/dashboard/PrimaryAlertBanner'
import SecurityAlertBanner from '@/components/dashboard/SecurityAlertBanner'
import LegalWelcomeBanner from '@/components/dashboard/LegalWelcomeBanner'
import ManageAndConversion from '@/components/dashboard/ManageAndConversion'
import Loader from '@/components/common/Loader'
import DataUpdateAlertBox from '@/components/common/DataUpdateAlertBox'
import DataUpdateAlertModal from '@/components/common/DataUpdateAlertModal'
import AdvancePOWidget from '@/components/dashboard/AdvancePOWidget'
import monitoringService from '@/services/monitoring'

export default {
  props: ['overlay'],
  data() {
    return {
      account: {},
      pendingTasks: [],
      showModal: false,
      // version: parseInt(this.$store.state.account.portalVersion),
      ddp: null,
      isDripSwitchEnabled: null,
      isDripSwitchApiFulfilled: false,
      isRateConversionApiFulfilled: false,
      confirmEnableINR: false,
      conversionRatesData: {
        rate: '',
        from_currency: '',
        to_currency: '',
        valid_till: ''
      },
      timeOutID: '',
      monitoringData: null,
      showINRDialog: false,
      isINREnabled: false,
      invoiceStageCounters: {},
      quickGlanceLoading: false,
      showEnableINRModal: false,
      lottieLoop: true,
      lottieJSON: Confetti,
      isAPIFullFilled: false,
      showLegalEsignBanner: false,
      bannerData: {},
      securityBannerData: {
        title: 'Fraud Alert',
        subtitle:
          'Scammers may pretend to be from Drip Capital using fake email addresses. They might send incorrect bank details or request for payments. Please Note: Drip Capital DOES NOT share any bank account updates on email. If you receive any such email, kindly raise it to your Account Manager and email at',
        writtenby: 'payments@dripcapital.com'
      },
      holidayDate: null,
      includesIndia: false,
      includesMexico: false
    }
  },
  computed: {
    newInvoiceRedirect() {
      if (
        !!this.monitoringData &&
        !!this.monitoringData.mail_date &&
        this.$moment(this.monitoringData.revoke_date).isValid() &&
        this.$moment(this.monitoringData.mail_date).isValid() &&
        (!this.monitoringData.financials.active ||
          !this.monitoringData.gst.active)
      ) {
        const mailDate = new Date(this.monitoringData.mail_date) // Convert to Date object
        const currentDate = new Date() // Get today's date

        // Calculate the date 45 days after the mail_date
        const days60AfterMailDate = new Date(mailDate)
        days60AfterMailDate.setDate(mailDate.getDate() + 60)

        return currentDate >= new Date(this.monitoringData.revoke_date)
      }
      return false
    },
    showDataUpdateAlert() {
      return (
        this.monitoringData &&
        this.$moment(this.monitoringData.revoke_date).isValid() &&
        (!this.monitoringData.financials.active ||
          !this.monitoringData?.gst.active)
      )
    },
    showBanner() {
      const isBeforeHoliday =
        this.normalizeDate(new Date()) <= this.normalizeDate(this.holidayDate)

      // Check if the current date is before the holiday date
      if (isBeforeHoliday) {
        // If the bannerData includes India and isIndia is true
        if (this.includesIndia && this.isIndia) {
          return true
        }

        // If the bannerData includes Mexico and isMexico is true
        if (this.includesMexico && this.isMexico) {
          return true
        }
      }

      // If none of the conditions are met, return false
      return false
    },
    fetchLottieJSON() {
      return JSON.stringify(this.lottieJSON)
    },
    ...mapState({
      activeTour: (state) => state.root.activeTour
    }),
    hasPermission() {
      return (
        this.$store.getters.hasPermission('esign') ||
        this.$store.getters.hasPermission('edit')
      )
    },
    hasAccessToInsights() {
      return (
        this.$store.state.account.account.role === 'exporters' &&
        this.$store.state.account.country === 'India'
      )
    },
    currentLocale() {
      return this.$store.state.account.currentLocale
    },
    isIndia() {
      return this.$store.state.account.country === 'India'
    },
    isMexico() {
      return this.$store.state.account.country === 'Mexico'
    },
    isNewUser() {
      return (
        this.$store.state.root.showBannerCount !== null &&
        this.$store.state.root.showBannerCount === 0
      )
    },
    isDialogVisible() {
      return (
        this.isIndia &&
        this.showINRDialog &&
        !this.isDripSwitchEnabled &&
        this.isDripSwitchApiFulfilled &&
        !this.isINREnabled
      )
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name) {
        localStorage.setItem('prevRoute', from.name)
      }
    })
  },
  mounted() {
    document.title = this.$t('dashboard.htmlTitle')
    this.$mpTrack('Dashboard page mounted')
    this.fetchMonitoringData()
    if (this.$store.state.account.accountId) {
      this.loadPendingTasks()
      this.getAccountData()
    }
    if (this.$route.query.esign === 'true') {
      this.esignSuccess()
    }
    if (this.isIndia && this.$route.query.legalEsign === 'true') {
      this.legalEsignSuccess()
    }
    if (!this.$route.query.legalEsign && this.getPrevRoutePath() === 'login') {
      this.getUserConfig()
    }
    if (this.$store.state.account.country === 'India') {
      this.showAndPrefillFreshdesk({ cf_category_i: 'Account related' }, null)
    }
    this.getConversionRate()
    this.getInvoiceData()
  },
  watch: {
    showLegalEsignBanner(newValue) {
      if (!newValue) {
        this.updateConfig()
      }
    },
    '$route.query.esign': {
      handler() {
        this.esignSuccess()
      }
    },
    bannerData() {},
    currentLocale: {
      handler() {
        this.getHolidayBanner()
      },
      immediate: true // This ensures that the handler is called immediately upon component creation
    }
  },
  created() {
    this.getHolidayBanner()
  },
  methods: {
    async fetchMonitoringData() {
      this.loading = true
      const res = await monitoringService.getMonitoringData(
        this.$store.getters.accountId
      )
      this.monitoringData = res.data
      this.checkModalDisplay()
      this.loading = false
    },
    checkModalDisplay() {
      if (
        !!this.monitoringData &&
        !!this.monitoringData?.mail_date &&
        this.$moment(this.monitoringData?.revoke_date).isValid() &&
        this.$moment(this.monitoringData?.mail_date).isValid() &&
        (!this.monitoringData?.financials.active ||
          !this.monitoringData?.gst.active)
      ) {
        const mailDate = new Date(this.monitoringData?.mail_date)
        const currentDate = new Date()
        const days50AfterMailDate = new Date(mailDate)
        days50AfterMailDate.setDate(mailDate.getDate() + 50)

        if (
          currentDate > days50AfterMailDate &&
          !sessionStorage.getItem('modalShown')
        ) {
          sessionStorage.setItem('modalShown', 'true')
          this.showModal = true
        }
      } else {
        this.showModal = false
      }
    },
    closeModalFn() {
      this.showLegalEsignBanner = false
    },
    getPrevRoutePath() {
      return localStorage.getItem('prevRoute')
    },
    redirectToCurrencySettings() {
      this.updateConfig()
      this.$mpTrack('Clicks "know more" from pop-up banner')
      this.$router.push({ name: 'currencySettings' })
    },
    redirectToAddInvoice() {
      if (this.newInvoiceRedirect) {
        this.$mpTrack('Dashboard - Redirected to accounts page', {
          revoke_date: this.monitoringData?.revoke_date
        })
        this.$router.push({ name: 'account' })
      } else {
        this.$mpTrack('Dashboard - Redirected to add new invoice page')
        this.$router.push({ name: 'invoicesAdd' })
      }
    },
    triggerLegalBannerModal() {
      this.legalEsignSuccess()
    },
    getUserConfig() {
      conversionRateService
        .getUserConfig(this.$store.state.account.accountId)
        .then((res) => {
          if (res && res.data.config) {
            const accountStatus =
              this.$store.state.account &&
              this.$store.state.account.account &&
              this.$store.state.account.account.status

            if (
              !res.data.config.switch_banner_count &&
              this.isIndia &&
              accountStatus === 'approved'
            ) {
              this.triggerLegalBannerModal()
            }
            if (
              (!res.data.config.switch_banner_count ||
                res.data.config.switch_banner_count < 3) &&
              accountStatus !== 'approved'
            ) {
              this.showINRDialog = true
            }
          }
          if (!res.data.config) {
            this.showINRDialog = true
          }
          this.showBannerCount =
            res.data.config && res.data.config.switch_banner_count
        })
        .catch((err) => {
          console.log(err)
        })
    },
    updateConfig() {
      if (this.$store.state.account.userType !== 'super_user') {
        let data = new FormData()
        data.append(
          'config',
          `{ "switch_banner_count": ${(this.showBannerCount || 0) + 1} }`
        )
        conversionRateService
          .updateUserConfig(this.$store.state.account.accountId, data)
          .then(() => {
            console.log('updated!')
          })
      }
    },
    closeDialog() {
      this.isINREnabled = false
      this.loadPendingTasks()
      this.showINRDialog = false
      this.updateConfig()
      this.$mpTrack('Clicks cross on pop-up banner')
    },
    onCloseIMMDialog() {
      this.isINREnabled = false
      this.showINRDialog = false
    },
    onCloseEMMDialog() {
      this.loadPendingTasks()
      this.showEnableINRModal = false
    },
    onCancelEMMDialog() {
      this.loadPendingTasks()
      this.showEnableINRModal = false
    },
    showConfirmationText() {
      this.$mpTrack('Clicks "Enable INR payments" from pop-up banner')
      this.confirmEnableINR = true
    },
    enableDripSwitchStatus() {
      this.isAPIFullFilled = true
      this.$mpTrack(`Enable 'User' INR Confirmation`)
      return invoiceService
        .updateRemittanceStatus({
          user_id: this.$store.state.account.accountId,
          enabled: true
        })
        .then(({ status, data }) => {
          this.isAPIFullFilled = false
          if (status === 200) {
            this.isINREnabled = true
            setTimeout(() => {
              this.lottieLoop = false
            }, 4000)
            this.loadPendingTasks()
            this.updateConfig()
          } else {
            this.$notify({
              title: this.$t('notifications.somethingWrong.title'),
              text: this.$t('notifications.somethingWrong.text'),
              type: 'error'
            })
          }
        })
        .catch(() => {
          this.isAPIFullFilled = false
          return this.$notify({
            title: this.$t('notifications.somethingWrong.title'),
            text: this.$t('notifications.somethingWrong.text'),
            type: 'error'
          })
        })
    },
    setFiltersandRedirect(newFilters) {
      this.$router.push({
        name: 'invoices',
        params: { alertFilters: newFilters }
      })
    },
    loadPendingTasks() {
      return exportersService
        .fetchExporterMetaData(this.$store.state.account.accountId, {
          include: ['customer_pending_task_flows']
        })
        .then((res) => {
          if (res && res.data) {
            this.pendingTasks = res.data.customer_pending_task_flows
            this.isDripSwitchEnabled = res.data.drip_switch_enabled
            this.isDripSwitchApiFulfilled = true
          }
        })
        .catch((err) => {
          this.isDripSwitchApiFulfilled = true
          console.log(err)
        })
    },
    handleDdp(ddp) {
      // Remove this function when corona shit is done, and everything is back to normal
      this.ddp = ddp
    },
    legalEsignSuccess() {
      if (!this.showLegalEsignBanner) {
        this.showLegalEsignBanner = true
      }
    },
    esignSuccess() {
      this.$notify({
        title: this.$t('notifications.esign.title'),
        text: this.$t('notifications.esign.text'),
        type: 'success'
      })
    },
    async getConversionRate() {
      this.isRateConversionApiFulfilled = false
      const exporterId = this.findExporter(
        this.$store.state.account.accountId
      ).id
      try {
        const { data } = await conversionRateService.getConversionRate(
          exporterId
        )
        this.isRateConversionApiFulfilled = true
        this.conversionRatesData = data
        let timeLeft = 0
        timeLeft = moment(this.conversionRatesData.valid_till).diff(new Date())
        let bufferAddedToTimeLeft = timeLeft + 100 // 100ms buffer added before making another API call so that we always fetch the newer data
        if (
          !bufferAddedToTimeLeft ||
          bufferAddedToTimeLeft < 0 ||
          bufferAddedToTimeLeft > MAXIMUM_SET_TIMEOUT_DELAY
        ) {
          bufferAddedToTimeLeft = RATE_CONVERSION_REFETCH_DEFAULT_TIME
        }
        clearTimeout(this.timeOutID)
        this.timeOutID = setTimeout(() => {
          this.getConversionRate()
        }, bufferAddedToTimeLeft)
      } catch (err) {
        this.isRateConversionApiFulfilled = true
        clearTimeout(this.timeOutID)
        this.timeOutID = setTimeout(() => {
          this.getConversionRate()
        }, RATE_CONVERSION_REFETCH_DEFAULT_TIME)
        console.log(err)
      }
    },
    getAccountData() {
      accountsService
        .fetchBusinessAccount({
          include: ['parent_user', 'plan']
        })
        .then((res) => {
          this.account = res.data
        })
        .catch()
    },
    findExporter(exporterId) {
      return this.$store.getters.user.linked_users.find((exporter) => {
        return parseInt(exporter.id) === parseInt(exporterId)
      })
    },
    getInvoiceData() {
      this.quickGlanceLoading = true
      exportersService
        .fetchInvoiceStageCounters(this.$store.state.account.accountId)
        .then((res) => {
          this.invoiceStageCounters = res.data
          this.quickGlanceLoading = false
        })
        .catch(() => {
          this.quickGlanceLoading = false
        })
    },
    async getHolidayBanner() {
      try {
        const res = await contentfulService.getHolidayBannerData()
        const entries = await res.json()
        const bannerTitle = 'Holiday banner'
        this.bannerData = entries.items.find(
          (item) => item.fields.title['en-US'] === bannerTitle
        )
        if (this.currentLocale === 'es-MX') {
          this.bannerData = this.bannerData.fields.data['es-ES']
        } else {
          this.bannerData = this.bannerData.fields.data['en-US']
        }

        const date = moment(this.bannerData.date, 'DD-MM-YYYY')
        this.holidayDate = date.toDate()

        // Check if the holiday includes India or Mexico
        this.includesIndia = this.bannerData.country.includes('India')
        this.includesMexico = this.bannerData.country.includes('Mexico')
      } catch (err) {
        console.error('Failed to fetch holiday banner:', err)
      }
    },
    normalizeDate(date) {
      const normalizedDate = new Date(date)
      normalizedDate.setHours(0, 0, 0, 0)
      return normalizedDate
    }
  },
  components: {
    QuickGlance,
    PendingInvoicesWidget,
    AdvanceInvoicesWidget,
    TransactionsWidget,
    PricingDetailsWidget,
    CurrencyConversion,
    NewAccountNumberWidget, // Remove DdpAlert when corona shit is done, and everything is back to normal
    DdpAlert, // Remove DdpAlert when corona shit is done, and everything is back to normal
    DialogBox,
    ActionButton,
    Alerts2,
    Warnings,
    MobilePromo,
    ManageAndConversion,
    PageHeader,
    PrimaryAlertBanner,
    SecurityAlertBanner,
    LegalWelcomeBanner,
    Loader,
    DataUpdateAlertBox,
    DataUpdateAlertModal,
    AdvancePOWidget
  },
  beforeDestroy() {
    clearTimeout(this.timeOutID)
  },
  mixins: [freshdeskMixin]
}
</script>
<style lang="scss">
button.close {
  color: $wealthy-green-500;
  margin-right: 9px !important;
  padding-right: 0 !important;
}
.modal-header {
  border-bottom: 0;
}
div#bv-modal-example___BV_modal_body_ {
  padding-top: 0;
}
</style>
<style lang="scss" scoped>
@import '../../assets/scss/variables';
.quick-glance-row {
  margin-bottom: 16px;
}

.dashboard-add-invoice {
  padding-top: 1.07rem;
  padding-bottom: 1.07rem;
}
.expose {
  z-index: 1;
}
.dialog-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .dialog-inner-container {
    background: $sky-blue-50;
    border-radius: 8px;
    .header {
      font-weight: 700;
      font-size: 36px;
      line-height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: $noble-blue-500;
      margin-top: 32px;
      margin-bottom: 12px;
    }
    .sub-header {
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: $noble-blue-500;
      margin-bottom: 32px;
    }
  }
  .button-container {
    display: flex;
    justify-content: center;
    .button-title {
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: $noble-blue-500;
      margin-bottom: 16px;
    }
    .button-subtitle {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      margin-bottom: 32px;
      justify-content: center;
      text-align: center;
      color: $black;
    }
  }
}
.inr-enabled-dialog-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
    object-fit: cover;
    height: 110px;
    width: 400px;
    margin: auto;
  }
  .header {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: $noble-blue-500;
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .sub-header {
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: $noble-blue-500;
  }
  .para {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    justify-content: center;
    color: $black;
    margin-bottom: 24px;
  }
}
</style>
